import { useEffect } from 'react'
import useComputePaddingGetter from './map.padding.utils'
import { MAP_FROM_APP_ACTION_PADDING } from './map.utils'
import { useCallbackWithMapContext } from './MapContext'
import { isEqual } from '../../utils/lang'

const useMapPaddingHandler = () => {
  const getPadding = useComputePaddingGetter()

  const setPadding = useCallbackWithMapContext(
    map => {
      const padding = getPadding()
      if (!isEqual(map.getPadding(), padding)) {
        map.setPadding(padding, { fromAppAction: MAP_FROM_APP_ACTION_PADDING })
      }
    },
    [getPadding]
  )

  useEffect(() => {
    setPadding()
  }, [setPadding])
}

export default useMapPaddingHandler
